import React, { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import classnames from 'classnames';



import cnIcon1 from '../../../images/icons/security/1.svg'
import cnIcon2 from '../../../images/icons/security/2.svg'
import cnIcon3 from '../../../images/icons/security/3.svg'
import cnIcon4 from '../../../images/icons/security/4.svg'
import cnIcon5 from '../../../images/icons/security/5.svg'
import cnIcon6 from '../../../images/icons/security/6.svg'
import cnIcon7 from '../../../images/icons/security/7.svg'
import cnIcon8 from '../../../images/icons/security/8.svg'
import cnIcon9 from '../../../images/icons/security/9.svg'
import cnIcon10 from '../../../images/icons/security/10.svg'
import cnIcon11 from '../../../images/icons/security/11.svg'
import cnIcon12 from '../../../images/icons/security/12.svg'
import cnIcon14 from '../../../images/icons/security/14.svg'
import cnIcon15 from '../../../images/icons/security/15.svg'
import cnIcon16 from '../../../images/icons/security/16.svg'
import cnIcon17 from '../../../images/icons/security/17.svg'
import cnIcon18 from '../../../images/icons/security/18.svg'
import cnIcon19 from '../../../images/icons/security/19.svg'
import cnIcon20 from '../../../images/icons/security/20.svg'
import cnIcon21 from '../../../images/icons/security/21.svg'
import cnIcon22 from '../../../images/icons/security/22.svg'
import cnIcon23 from '../../../images/icons/security/23.svg'
import cnIcon24 from '../../../images/icons/security/24.svg'
import cnIcon25 from '../../../images/icons/security/25.svg'
import cnIcon26 from '../../../images/icons/security/26.svg'
import cnIcon27 from '../../../images/icons/security/27.svg'
import cnIcon28 from '../../../images/icons/security/28.svg'
import cnIcon29 from '../../../images/icons/security/29.svg'
import cnIcon30 from '../../../images/icons/security/30.svg'
import cnIcon31 from '../../../images/icons/security/31.svg'
import cnIcon32 from '../../../images/icons/security/32.svg'
import cnIcon33 from '../../../images/icons/security/33.svg'
import cnIcon34 from '../../../images/icons/security/34.svg'
import cnIcon35 from '../../../images/icons/security/35.svg'
import cnIcon36 from '../../../images/icons/security/36.svg'
import cnIcon38 from '../../../images/icons/security/38.svg'
import cnIcon39 from '../../../images/icons/security/39.svg'
import cnIcon40 from '../../../images/icons/security/40.svg'
import cnIcon41 from '../../../images/icons/security/41.svg'
import cnIcon42 from '../../../images/icons/security/42.svg'
import cnIcon43 from '../../../images/icons/security/43.svg'
import Bg from '../../../images/shapes/shape_title_under_line.svg'


const SecurityToolsList = [
    // Web & Network Security
    {
        Id: '1',
        sIcon: cnIcon1,
        title: 'Wireshark',
    },
    {
        Id: '2',
        sIcon: cnIcon25,
        title: 'Nmap',
    },
    {
        Id: '3',
        sIcon: cnIcon2,
        title: 'Graylog',
    },
    {
        Id: '4',
        sIcon: cnIcon4,
        title: 'Snort',
    },
    {
        Id: '5',
        sIcon: cnIcon36,
        title: 'Zeek (Bro)',
    },
    {
        Id: '6',
        sIcon: cnIcon28,
        title: 'OpenVAS',
    },

    // Compliance
    {
        Id: '7',
        sIcon: cnIcon19,
        title: 'ISO 27001',
    },
    {
        Id: '8',
        sIcon: cnIcon24,
        title: 'NIS2',
    },
    {
        Id: '9',
        sIcon: cnIcon23,
        title: 'NEN 7510',
    },
    {
        Id: '10',
        sIcon: cnIcon26,
        title: 'OneTrust',
    },
    {
        Id: '11',
        sIcon: cnIcon38,
        title: 'Tenable SC',
    },
    {
        Id: '12',
        sIcon: cnIcon39,
        title: 'Qualys',
    },

    // Endpoint Security
    {
        Id: '13',
        sIcon: cnIcon29,
        title: 'OSSEC',
    },
    {
        Id: '14',
        sIcon: cnIcon3,
        title: 'ClamAV',
    },
    {
        Id: '15',
        sIcon: cnIcon7,
        title: 'Sysmon',
    },
    {
        Id: '16',
        sIcon: cnIcon5,
        title: 'CrowdStrike Falcon',
    },
    {
        Id: '17',
        sIcon: cnIcon10,
        title: 'Carbon Black',
    },
    {
        Id: '18',
        sIcon: cnIcon22,
        title: 'McAfee Endpoint Security',
    },

    // Cloud & DevOps Security
    {
        Id: '19',
        sIcon: cnIcon11,
        title: 'CloudMapper',
    },
    {
        Id: '20',
        sIcon: cnIcon34,
        title: 'Trivy',
    },
    {
        Id: '21',
        sIcon: cnIcon20,
        title: 'kube-bench',
    },
    {
        Id: '22',
        sIcon: cnIcon8,
        title: 'Aqua Security',
    },
    {
        Id: '23',
        sIcon: cnIcon30,
        title: 'Palo Alto Prisma Cloud',
    },
    {
        Id: '24',
        sIcon: cnIcon9,
        title: 'AWS GuardDuty',
    },
    // Vulnerability Management
    {
        Id: '25',
        sIcon: cnIcon27,
        title: 'OpenSCAP',
    },
    {
        Id: '26',
        sIcon: cnIcon38,
        title: 'Tenable Nessus',
    },
    {
        Id: '27',
        sIcon: cnIcon39,
        title: 'Qualys',
    },
    {
        Id: '28',
        sIcon: cnIcon31,
        title: 'Rapid7 Nexpose',
    },

    // SIEM
    {
        Id: '29',
        sIcon: cnIcon14,
        title: 'ELK Stack',
    },
    {
        Id: '30',
        sIcon: cnIcon29,
        title: 'OSSEC',
    },
    {
        Id: '31',
        sIcon: cnIcon35,
        title: 'Wazuh',
    },
    {
        Id: '32',
        sIcon: cnIcon6,
        title: 'Splunk Enterprise Security',
    },
    {
        Id: '33',
        sIcon: cnIcon18,
        title: 'IBM QRadar',
    },
    {
        Id: '34',
        sIcon: cnIcon21,
        title: 'LogRhythm',
    },

    // Penetration Testing
    {
        Id: '35',
        sIcon: cnIcon40,
        title: 'Kali Linux',
    },
    {
        Id: '36',
        sIcon: cnIcon41,
        title: 'Metasploit Framework',
    },
    {
        Id: '37',
        sIcon: cnIcon33,
        title: 'SQLmap',
    },
    {
        Id: '38',
        sIcon: cnIcon16,
        title: 'Hydra',
    },
    {
        Id: '39',
        sIcon: cnIcon42,
        title: 'Core Impact',
    },
    {
        Id: '40',
        sIcon: cnIcon12,
        title: 'Cobalt Strike',
    },

    // Incident Response and Forensics
    {
        Id: '41',
        sIcon: cnIcon43,
        title: 'Volatility',
    },
    {
        Id: '42',
        sIcon: cnIcon32,
        title: 'Autopsy',
    },
    {
        Id: '43',
        sIcon: cnIcon17,
        title: 'FireEye Endpoint Security',
    },
    {
        Id: '44',
        sIcon: cnIcon6,
        title: 'CrowdStrike Falcon Insight',
    },
    {
        Id: '45',
        sIcon: cnIcon15,
        title: 'EnCase',
    },
];



const TechnologySection = (props) => {
    const [activeTab, setActiveTab] = useState('1');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const navigationItems = [
        { id: '1', title: 'Web & Network Security' },
        { id: '2', title: 'Compliance' },
        { id: '3', title: 'Endpoint Security' },
        { id: '4', title: 'Cloud & DevOps Security' },
        { id: '5', title: 'Vulnerability Management' },
        { id: '6', title: 'SIEM' },
        { id: '7', title: 'Penetration Testing' },
        { id: '8', title: 'Incident Response and Forensics' }
    ];

    const handleItemClick = (tab) => {
        setActiveTab(tab);
        setDropdownOpen(false); // Explicitly close the dropdown
    };

    useEffect(() => {
        const checkWindowSize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkWindowSize();
        window.addEventListener('resize', checkWindowSize);

        return () => window.removeEventListener('resize', checkWindowSize);
    }, []);

    const toggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
        setDropdownOpen(false); // This ensures dropdown closes after selection
    }

    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

    const getSliceIndexes = (tabId) => {
        switch (tabId) {
            case '1': return [0, 6];
            case '2': return [7, 12];
            case '3': return [13, 18];
            case '4': return [19, 24];
            case '5': return [25, 28];
            case '6': return [29, 34];
            case '7': return [35, 40];
            case '8': return [41, 45];
            default: return [0, 6];
        }
    };

    return (
        <div className="section_space">
            <div className="heading_block text-center">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                    Onze technologieën
                </div>
                <h2 className="heading_text mb-0">
                    Onze <mark>Beveiligings</mark>tools
                </h2>
            </div>

            <div className="tab_block_wrapper">
                {isMobile ? (
                    <div className="position-relative z-50 mb-4">
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="w-100">
                            <DropdownToggle caret className="w-100 text-left btn btn-primary text-white py-3 px-4 d-flex justify-content-between align-items-center">
                                <span>{navigationItems.find(item => item.id === activeTab)?.title}</span>
                            </DropdownToggle>
                            <DropdownMenu className="w-100 shadow-lg py-2">
                                {navigationItems.map(item => (
                                    <DropdownItem
                                        key={item.id}
                                        onClick={() => handleItemClick(item.id)}
                                        active={activeTab === item.id}
                                        className="px-4 py-3 hover:bg-gray-100"
                                    >
                                        {item.title}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                ) : (
                    <Nav tabs className="nav justify-content-center">
                        {navigationItems.map(item => (
                            <NavItem key={item.id}>
                                <NavLink
                                    className={classnames({ active: activeTab === item.id })}
                                    onClick={() => handleItemClick(item.id)}
                                >
                                    {item.title}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                )}

                <TabContent activeTab={activeTab}>
                    {navigationItems.map(item => {
                        const [start, end] = getSliceIndexes(item.id);
                        return (
                            <TabPane key={item.id} tabId={item.id}>
                                <div className="web_development_technologies row justify-content-center">
                                    {SecurityToolsList.slice(start, end).map((technology, cnt) => (
                                        <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={cnt}>
                                            <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                                                <div className="iconbox_icon">
                                                    <img src={technology.sIcon} alt="" />
                                                </div>
                                                <div className="iconbox_content">
                                                    <h3 className="iconbox_title mb-0">{technology.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
        </div>
    );
};

export default TechnologySection;
